module.exports = __webpack_public_path__ + "static/img/F1.7b0172e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mjhl2/F1.png
// module id = XFJQ
// module chunks = 0